import { render, staticRenderFns } from "./Procedimiento.vue?vue&type=template&id=3d177e2b"
import script from "./Procedimiento.vue?vue&type=script&lang=js"
export * from "./Procedimiento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports